import DesktopLayout from '../../layouts/DesktopLayout';
import AppPairingContent from '../shared/AppPairingContent';

type Props = {
  pairingCode: string;
  onCancel: () => void;
  onCompletePairing: () => void;
  onBack?: () => void;
};

export default function DesktopAppPairingPage(props: Props) {
  return (
    <DesktopLayout>
      <AppPairingContent {...props} />
    </DesktopLayout>
  );
}
